import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'

import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './api/axios-default'
import * as Sentry from '@sentry/vue'

Vue.use(VueCompositionApi)

Vue.config.productionTip = false

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    // 'localhost',
    'https://staging-app.sbf-ocr.com/',
    'https://app.sbf-ocr.com/',
  ],
  // Session Replay
  // replaysSessionSampleRate: 0.1, // リプレイ機能はエラーのみでよいと判断
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
